<script setup lang="ts">
import type { ServicesIconType } from '@design-system/mocks/helpIconTypes'

definePageMeta({
  layout: 'customer-service-layout',
})

const { getCanonicalUrl } = useRouteHelper()
const { serviceShortcutsIcons } = useShortcuts()

const { pageContent } = await useLegalArea('help-area-pages')

const giantShortcut = computed(
  () => pageContent?.value?.content?.giantShortcut ?? []
)
</script>

<template>
  <div
    class="mt-lg md:mt-4xl mb-md md:mb-xxl gap-y-md md:gap-y-xxl flex flex-col"
  >
    <h2 class="text-book-4 md:text-book-3">
      {{ $ts('customerService.welcome') }}
    </h2>
    <div class="p-md md:p-xxl bg-neutral-white gap-md md:gap-xxl flex flex-col">
      <div
        v-if="!!giantShortcut.length"
        class="flex flex-wrap gap-3 md:flex-row"
      >
        <AtomsGiantShortcut
          v-for="shortcut in giantShortcut"
          :key="shortcut.name"
          :text="shortcut?.name ?? ''"
          :link="getCanonicalUrl(shortcut.url?.target?.target ?? '')"
          :disabled="!shortcut.url?.target?.target"
          class="min-w-[295px] flex-[1_1_33%] md:min-w-0 md:flex-1"
        >
          <template #icon>
            <component
              :is="
                serviceShortcutsIcons[shortcut.icon as ServicesIconType]?.icon
              "
              v-if="
                shortcut.icon &&
                serviceShortcutsIcons[shortcut.icon as ServicesIconType]
              "
              class="h-xxl w-xxl md:h-4xl md:w-4xl shrink-0 stroke-[0.5]"
              :aria-hidden="true"
            />
          </template>
        </AtomsGiantShortcut>
      </div>
      <CustomerService
        v-if="pageContent"
        :content="pageContent?.content"
        is-child-component
      >
      </CustomerService>
    </div>
  </div>
</template>
